import type { Site } from "rivals/shared/interfaces/Site";

export enum ALERT_TYPES {
  Alert = "Alert",
  Article = "Article",
  Decommitment = "Decommitment",
  EntersTransferPortal = "Enters Transfer Portal",
  IntendsToEnterTransferPortal = "Intends to Enter Transfer Portal",
  OfficialSchoolVisit = "Official School Visit",
  SchoolOffer = "School Offer",
  Signed = "Signed",
  SoftVerbalCommitment = "Soft Verbal Commitment",
  Transfer = "Transfer",
  UnofficialSchoolVisit = "Unofficial School Visit",
  VerbalCommitment = "Verbal Commitment",
  WithdrawsFromTransferPortal = "Withdraws from Transfer Portal"
}

export interface Props {
  logout: () => void;
  site?: Site;
}
